import PropTypes from 'prop-types';

const sxPropType = PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]);

export default sxPropType;
